import React, { useEffect, useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import { Button } from "../StyledElements";
import { useNavigate } from "react-router-dom";
import { useAgents } from "../../contexts/AgentsContext";

DataTable.use(DT);

const AgentsTable = ({ agents = [], isDataSet = false, hideTitle = false, hideButtons = false, showAddExisting = false, mode = null, onSelect = () => { } }) => {
  const { setUpdatedAgent } = useAgents();
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [localAgents, setLocalAgents] = useState(agents);

  window.edit = (public_id) => {
    setUpdatedAgent(null);
    navigate(`/agent/${public_id}`);
  }

  const tableData = agents.map((agent) => {
    return [agent.public_id, agent.name, agent.description, `<div style="display: flex; flex-direction: row;"><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.edit('${agent.public_id}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button></div`,
    ];
  });

  useEffect(() => {
    setLocalAgents(agents);
  }, [agents]);

  return (
    <div style={{ width: "100%", position: "relative", paddingLeft: "20px", paddingRight: "20px" }}>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        {!hideTitle ? (
          <div>Agents</div>
        ) : null}
        <div style={{ fontSize: "16px", fontStyle: "italic", fontWeight: "normal" }}>
          {localAgents.length.toLocaleString()} agents
        </div>
        <div style={{ position: "absolute", right: "20px", top: "30px", display: "flex", flexDirection: "row", gap: "10px" }}>
          <Button
            onClick={() => {
              console.log("Navigate to create agent");
              navigate(`/agent/create`);
            }}
          >+ Create Agent</Button>
        </div>
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default AgentsTable;
